import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../config/consts";

import BackHeader from "./BackHeader";

class ClientBackHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clientName: "",
      clientId: "",
    };
  }

  componentDidMount() {
    axios
      .get(
        BACKEND_CONFIG.apiUrl +
          "agency/clients/" +
          this.props.clientId +
          "/information"
      )
      .then((result) => {
        this.setState({
          clientName: result.data.Name,
          clientId: result.data.ClientId,
        });
      });
  }

  render() {
    return (
      <BackHeader
        text={this.state.clientName}
        infoText={"Client ID: " + this.state.clientId}
        onClick={() => this.props.goBack()}
      />
    );
  }
}

export default ClientBackHeader;
